
import React from 'react'
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function HomeChalenge() {
    return (
        <>
            <div className="home-challenge">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-6 col-md-5">
                            <img src="/image/challenge.webp" className="img-responsive challenge-image" alt="challenge" loading="lazy" />
                        </div>

                        <div className="col-lg-6 col-md-7">
                            <div className="challenge-detail">
                                <h2 className="heading">A Curriculum that <span className="highlight">Challenges</span></h2>
                                <p>At Lucknow Public School, our curriculum is designed to foster academic excellence,
                                    discipline, and holistic development. By integrating rigorous academics with co-curricular
                                    activities, sports, life skills, and value-based learning, we nurture confident, creative, and
                                    responsible individuals. Through experiential learning and a student-centric approach, we
                                    empower every learner to think critically, lead with integrity, and excel in an ever-evolving
                                    world.</p>
                                {/* <Link to={"/"} className="arrow-butn">Learn More <Icons name="Longarrow_right"/></Link> */}

                                <img src="/image/challenge.webp" className="img-responsive" alt="challenge" loading="lazy" />

                                <div className="path-links">
                                    <Link to={""} className="circle-path cpath-1 wow animate__animated animate__zoomIn">Exploration Years</Link>

                                    <Link to={""} className="circle-path cpath-2 wow animate__animated animate__zoomIn">Inspiration Years</Link>

                                    <Link to={""} className="circle-path cpath-3 wow animate__animated animate__zoomIn">Discovery Years</Link>

                                    <img src="/image/path-line.svg" className="path-image" alt="path" />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}
